import { CONFIG } from '../../configuration'

/**
 * API URL obtained from the configuration (synchronous).
 * It is evaluated dynamically each time it is accessed to ensure
 * that it uses the cached configuration correctly.
 *
 * It is used as a string in template literals and can access properties
 * of the string, so it implements toString(), valueOf(), Symbol.toPrimitive
 * and delegates all properties to the real string.
 */
class APIURLProxy {
  private get value(): string {
    return CONFIG.API_URL
  }

  toString() {
    return this.value
  }

  valueOf() {
    return this.value
  }

  [Symbol.toPrimitive](hint: string) {
    return this.value
  }
}

// Create a Proxy that delegates all properties to the real string
export const API_URL: string = new Proxy(new APIURLProxy(), {
  get(target, prop) {
    if (
      prop === 'toString' ||
      prop === 'valueOf' ||
      prop === Symbol.toPrimitive
    ) {
      return target[prop as keyof APIURLProxy].bind(target)
    }
    // For any other property, get the string value and delegate
    const stringValue = CONFIG.API_URL
    return (stringValue as any)[prop]
  },
  has(_target, prop) {
    // Delegate to String.prototype
    return prop in String.prototype || prop in new APIURLProxy()
  },
}) as unknown as string

// Also export a helper function in case
export function getAPI_URL(): string {
  return CONFIG.API_URL
}

export class UnathorizedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'INVALID_TOKEN'
  }
}

export class APIError extends Error {
  public status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

export class NetworkError extends Error {}
